'use strict';
import * as $j_app$002etulz$002etuplez$002e$002dComposition from "./app.tulz.tuplez.-Composition.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5() {
}
export { $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5 as $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5 };
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5.prototype = new $j_app$002etulz$002etuplez$002e$002dComposition.$h_Lapp_tulz_tuplez_Composition();
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5.prototype.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5() {
}
export { $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5 as $h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5 };
$h_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5.prototype = $c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5.prototype;
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5.prototype.decompose__T3__T2 = (function(c) {
  var _1$1 = c.T3__f__1;
  var _1 = c.T3__f__2;
  var _2 = c.T3__f__3;
  var _2$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2$1);
});
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5.prototype.compose__O__O__O = (function(a, b) {
  var _2 = b._1__O();
  var _3 = b._2__O();
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T3(a, _2, _3);
});
$c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5.prototype.decompose__O__T2 = (function(c) {
  return this.decompose__T3__T2(c);
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5, "app.tulz.tuplez.Composition_Pri7$$anon$5", ({
  Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5: 1,
  Lapp_tulz_tuplez_Composition: 1
}));
export { $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5 as $d_Lapp_tulz_tuplez_Composition\uff3fPri7$$anon$5 };
//# sourceMappingURL=app.tulz.tuplez.-Composition_-Pri7$$anon$5.js.map
